import { Trans } from 'react-i18next';

import { Translate, useTranslateDeclension } from '@dreryk/react-common';
import { Text } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { numberAssignedPatientsVisitor } from './CustomPatientGroupsRemoveModal.utils';

type CustomPatientGroupsRemoveModalContentProps = {
   patientGroupName: string;
   numberAssignedPatients: number;
};

export const CustomPatientGroupsRemoveModalContent = (
   props: CustomPatientGroupsRemoveModalContentProps
): JSX.Element => {
   const declensionForm = useTranslateDeclension(
      props.numberAssignedPatients,
      translationKeys.patientAccusative,
      translationKeys.patientGenitive,
      translationKeys.patientPlural
   );

   return (
      <>
         <div>
            <Trans
               i18nKey={translationKeys.areYouSureYouWantToRemoveGroup}
               values={{ patientGroupName: props.patientGroupName }}
               components={{ bold: <strong /> }}
            />
         </div>
         <div>
            {numberAssignedPatientsVisitor(props.numberAssignedPatients)({
               visitNoAssignedPatients: () => (
                  <Text testId={'groupIsNotAssignedToAnyone'}>
                     <Translate>{translationKeys.customGroupIsNotAssignedToAnyone}</Translate>
                  </Text>
               ),
               visitAssignedPatients: (numberAssignedPatients) => (
                  <Trans
                     i18nKey={translationKeys.customGroupAssignedTo}
                     values={{ numberAssignedPatients: numberAssignedPatients, declensionForm: declensionForm }}
                     components={{ bold: <strong /> }}
                  />
               ),
            })}
         </div>
      </>
   );
};
